import React from "react";
import HeroNew from "./HeroNew";
import Products from "./Products";
import Benefits from "./Benefits";
import AboutNew from "./AboutNew";
import Contact from "./Contact";
import FAQ from "./FAQ";
import "../HomeStyles.css";

export default function Home() {
  React.useEffect(() => {
    document.title = "Premium Hair Care Products | Advanced Hair Care Solutions - Calyx Professional";
    
    // Dynamically update or create description meta tag
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Upgrade your routine with premium hair care products and advanced hair care solutions for healthier-looking hair. Choose Calyx Professional today.");
    } else {
      metaDescription = document.createElement('meta');
      metaDescription.name = "description";
      metaDescription.content = "Upgrade your routine with premium hair care products and advanced hair care solutions for healthier-looking hair. Choose Calyx Professional today.";
      document.head.appendChild(metaDescription);
    }
  }, []);

  return (
    <div className="home-container">
      <section id="home">
        <HeroNew />
      </section>
      
      <section id="products">
        <Products />
      </section>
      
      <section id="benefits">
        <Benefits />
      </section>
      
      <section id="about">
        <AboutNew />
      </section>
      
      <section id="faq" style={{ padding: '80px 5%', background: '#fff' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', fontSize: '2.8rem', color: '#333', marginBottom: '40px' }}>Frequently Asked Questions</h2>
          <FAQ />
        </div>
      </section>
      
      <section id="contact">
        <Contact />
      </section>
    </div>
  );
}
